<template>
  <b-card v-if="data" no-body>
    <b-card-body class="p-0">
      <b-row class="mb-4">
        <b-col sm="2" class="d-flex flex-column flex-wrap text-center">
          <h1 class="font-large-2 font-weight-bolder mt-2 mb-0">
            {{ data.totalOrders }}
          </h1>
          <span>Total de órdenes</span>
        </b-col>

        <!-- chart -->
        <b-col sm="10" class="d-flex justify-content-center">
          <!-- apex chart -->
          <vue-apex-charts
            type="radialBar"
            height="270"
            :options="supportTrackerRadialBar.chartOptions"
            :series="data.supportTrackerRadialBar.series"
          />
        </b-col>
        <!--/ chart -->
      </b-row>

      <!-- chart info: responsive 5-column grid -->
      <b-row class="match-height">
        <div class="orders-grid w-100">
          <div class="order-item">
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar size="48" :variant="showOrderColor('Generada')">
                  <feather-icon size="24" :icon="showOrderIcon('Generada')" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">{{ data.generated }}</h4>
                <b-card-text class="font-small-3 mb-0"> Generada </b-card-text>
              </b-media-body>
            </b-media>
          </div>

          <div class="order-item">
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar size="48" :variant="showOrderColor('Atendida')">
                  <feather-icon size="24" :icon="showOrderIcon('Atendida')" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">{{ data.attended }}</h4>
                <b-card-text class="font-small-3 mb-0"> Atendida </b-card-text>
              </b-media-body>
            </b-media>
          </div>

          <div class="order-item">
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar size="48" :variant="showOrderColor('Procesada')">
                  <feather-icon size="24" :icon="showOrderIcon('Procesada')" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">{{ data.processed }}</h4>
                <b-card-text class="font-small-3 mb-0"> Procesada </b-card-text>
              </b-media-body>
            </b-media>
          </div>

          <div class="order-item">
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar size="48" :variant="showOrderColor('Terminada')">
                  <feather-icon size="24" :icon="showOrderIcon('Terminada')" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">{{ data.finished }}</h4>
                <b-card-text class="font-small-3 mb-0"> Terminada </b-card-text>
              </b-media-body>
            </b-media>
          </div>

          <div class="order-item">
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar size="48" :variant="showOrderColor('Rechazada')">
                  <feather-icon size="24" :icon="showOrderIcon('Rechazada')" />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">{{ data.rejected }}</h4>
                <b-card-text class="font-small-3 mb-0"> Rechazada </b-card-text>
              </b-media-body>
            </b-media>
          </div>
        </div>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BDropdown,
  BDropdownItem,
  BCardBody,
  BRow,
  BCol,
  BCardText,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      supportTrackerRadialBar: {
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: 20,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: "65%",
              },
              track: {
                background: "#fff",
                strokeWidth: "100%",
              },
              dataLabels: {
                name: {
                  offsetY: -5,
                  color: "#5e5873",
                  fontSize: "1rem",
                },
                value: {
                  offsetY: 15,
                  color: "#5e5873",
                  fontSize: "1.714rem",
                },
              },
            },
          },
          colors: [$themeColors.danger],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.primary],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            dashArray: 8,
          },
          labels: ["Terminadas"],
        },
      },
    };
  },
  methods: {
    showOrderIcon(status) {
      switch (status) {
        case "Generada":
          return "WatchIcon";
        case "Atendida":
          return "PhoneCallIcon";
        case "Procesada":
          return "CheckCircleIcon";
        case "Terminada":
          return "TrendingUpIcon";
        case "Rechazada":
          return "TrendingDownIcon";
        default:
          return "HelpCircleIcon";
      }
    },

    showOrderColor(status) {
      switch (status) {
        case "Generada":
          return "light-warning";
        case "Atendida":
          return "light-primary";
        case "Procesada":
          return "light-info";
        case "Terminada":
          return "light-success";
        case "Rechazada":
          return "light-danger";
        default:
          return "light-secondary";
      }
    },
  },
};
</script>
<style scoped>
.orders-grid {
  display: flex;
  flex-wrap: wrap;
  margin: -0.5rem;
}
.order-item {
  padding: 0.5rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.order-item .b-media {
  width: 100%;
}
/* Responsive: 1 col mobile, 2 col small, 3 col md, 5 col lg+ */
.order-item {
  flex: 0 0 100%;
  max-width: 100%;
}
@media (min-width: 576px) {
  .order-item {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 768px) {
  .order-item {
    flex: 0 0 33.3333%;
    max-width: 33.3333%;
  }
}
@media (min-width: 992px) {
  .order-item {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>
